import api from '../config/api';

const base = '/api/admin/content-sections';

/** Dashboard → Content Sections. All calls are admin-only on the server. */
const contentSectionService = {
  async list({ search, type, status } = {}) {
    const params = {};
    if (search) params.search = search;
    if (type !== undefined && type !== '' && type !== null) params.type = type;
    if (status && status !== 'all') params.status = status;
    return (await api.get(base, { params })).data;
  },
  async options() {
    return (await api.get(`${base}/options`)).data;
  },
  async get(id) {
    return (await api.get(`${base}/${id}`)).data;
  },
  async create(body) {
    return (await api.post(base, body)).data;
  },
  async update(id, body) {
    return (await api.put(`${base}/${id}`, body)).data;
  },
  async remove(id) {
    await api.delete(`${base}/${id}`);
  },
  async duplicate(id) {
    return (await api.post(`${base}/${id}/duplicate`)).data;
  },
  async setActive(id, isActive) {
    await api.post(`${base}/${id}/active`, { isActive });
  },
  /** items: [{ sectionId, zone, sortOrder }] */
  async reorder(items) {
    await api.put(`${base}/reorder`, { items });
  },
  /** Preview an unsaved draft (id only seeds the stable random order). */
  async preview(body, id) {
    return (await api.post(`${base}/preview`, body, { params: id ? { id } : {} })).data;
  },
  async previewSaved(id) {
    return (await api.get(`${base}/${id}/preview`)).data;
  },
  async productLookup(body) {
    return (await api.post(`${base}/product-lookup`, body)).data;
  },
};

export default contentSectionService;
